import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment/moment";

/* Components */
import { FontBody16, FontBody12 } from "../../../../common/components/fonts";
import { colors } from "../../../../common/components/colors";
import { ButtonSecondary } from "../../../../common/components/buttons";
import Popup from "./conversation";
import { tryGetLeadDetails } from "../middleware/prospects";
import { Relative } from "./prospectelements";
import LeadRequestStatus from "./prospects/prospectStatus";

import getDomainEnv from "../../../../domains/utils";
const env = getDomainEnv();

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 720px) {
        flex-direction: row;
        align-items: center;
    }
`;
const Col = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
const ColName = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media screen and (max-width: 720px) {
        flex-direction: row;
        width: 100%;
        text-align: left;
        padding-bottom: 10px;
    }
`;

const FirstCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    @media screen and (max-width: 720px) {
        flex-direction: row;
        width: 100%;
        text-align: left;
        padding-bottom: 10px;
    }
`;
const RowCTA = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 200px;
    @media screen and (max-width: 720px) {
        flex-direction: row;
        width: 100%;
        align-items: center;
    }
`;
const ColCTA = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 25px;
    text-align: center;
    max-width: 200px;
    width: 100%;
    & > div {
        margin: 0 auto;
    }
`;
const ProspectBackground = styled.div`
    // background-color: ${(props) => props.backgroundColor};
    // padding: 20px;
    // border-radius: 20px 0 20px 0;
`;
const ProspectInside = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 20px 0 20px 0;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
`;
const DateBox = styled.div`
    background-color: ${colors.primary70};
    padding: 20px;
    text-align: center;
    border-radius: 10px;
    color: white;
    max-width: 180px;
    width: 100%;
    align-content: center;
    overflow-wrap: break-word;
    @media screen and (max-width: 720px) {
        padding: 10px;
        max-width: 120px;
    }
    //box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.12);
`;

const MediaBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 60%;
    align-items: center;
    @media screen and (max-width: 720px) {
        flex-direction: column;
        gap: 10px;
        width: none;
    }
`;

const Web = styled.div`
    display: flex;
    text-align: center;
    padding-right: 5px;
    @media screen and (max-width: 720px) {
        display: none;
    }
`;

const Mobile = styled.div`
    display: none;
    @media screen and (max-width: 720px) {
        display: flex;
    }
`;

const InputSectionSelect = styled.div`
    text-align: left;
    padding: 10px 20px;
    background-color: ${colors.white};
    border: 0px solid ${colors.primary30};
    border-radius: 100px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.25);

    select {
        border: 0px solid ${colors.primary30};
        color: ${colors.primary100};
        width: 100%;
        font-family: ${env.STYLES.FONTS.body.fontFamily};
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        :hover {
            cursor: pointer;
        }

        &::placeholder {
            color: ${colors.primary70};
        }
        &:focus {
            outline: none;
        }
    }
`;

export default function FirmMarketingProspectRecord({ prospect, selectStatus, index }) {
    const [conversation, setConversation] = useState([]);
    const [dialogLoading, setDialogLoading] = useState(false);
    const [isDialogVisible, setIsDialogVisible] = useState(false);

    const showConversationDialog = async () => {
        setIsDialogVisible(true);
        setDialogLoading(true);
        await fetchConversations(prospect.id);
        setDialogLoading(false);
    };

    const fetchConversations = async (userID) => {
        const leadDetails = await tryGetLeadDetails(userID);
        setConversation(leadDetails.conversation);
    };

    const handleStatusChange = async (leadId, statusValue) => {
        await selectStatus(leadId, statusValue);
    };

    const formatPhone = (number) => {
        if (number === null || number === undefined ||number.length === 0) {
            return "-"
        }
        if (number.length !== 10) {
            return number; // Return as is if not a valid phone number
        }
        const first = number.substring(0, 3);
        const mid = number.substring(3, 6);
        const end = number.substring(6);
        return `(${first})-${mid}-${end}`;
    };
    /**
     * Capitalizes the first letter of a string.
     * @param {string | undefined} str 
     * @returns {string}
     */
    const capitalize = (str) => {
        if (!str || str.length === 0) {
            return "";
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        <ProspectBackground backgroundColor={colors.prospectColors[index % colors.prospectColors.length]}>
            <ProspectInside>
                <Row>
                    <MediaBox>
                        <FirstCol>
                            <ColName style={{ textAlign: "center" }}>
                                <FontBody16>{moment(prospect.createdOn).format("MMM DD, YYYY")}</FontBody16>
                            </ColName>
                            <Web onClick={() => showConversationDialog(prospect.id)}>
                                <ButtonSecondary canSubmit={false} label={"Show Conversation"} />
                            </Web>
                        </FirstCol>
                        <RowCTA>
                            <DateBox>
                                <Col>
                                    <FontBody16 style={{ fontFamily: "MontserratSemiBold" }}>
                                        {capitalize(prospect.firstName)} {capitalize(prospect.lastName)}
                                    </FontBody16>
                                    <FontBody12>{formatPhone(prospect.phone)}</FontBody12>
                                    <FontBody12>{prospect.email}</FontBody12>
                                </Col>
                            </DateBox>
                        </RowCTA>
                    </MediaBox>
                    <ColCTA>
                        <Relative>
                            <InputSectionSelect>
                                <select
                                    name={"prospectstatus"}
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            return ;
                                        }
                                        handleStatusChange(prospect.id, e.target.value);
                                    }}
                                    value={prospect.statusCode}
                                >
                                    <option value={""}>
                                        ------
                                    </option>
                                    {LeadRequestStatus.getDropdownOptions().map((d, index) => (
                                        <option key={d.value} value={d.value}>
                                            {d.label}
                                        </option>
                                    ))}
                                </select>
                            </InputSectionSelect>
                        </Relative>
                        <Mobile onClick={() => showConversationDialog(prospect.id)}>
                            <ButtonSecondary canSubmit={false} label={"Show Conversation"} />
                        </Mobile>
                    </ColCTA>
                </Row>
                {isDialogVisible && (
                    <Popup
                        conversation={conversation}
                        onClose={() => {
                            setIsDialogVisible(false);
                        }}
                        name={prospect.firstName}
                        isLoading={dialogLoading}
                    />
                )}
            </ProspectInside>
        </ProspectBackground>
    );
}
